import axios from 'axios'
import {API} from 'src/feature/bite/domain'

interface SubscriptionForm {
  subscriptionID: string
  merchantID: string
}

interface Response {
  response: any
  responseResult: {
    result: boolean
    exceptionDetail: string
  }
}

export default async function subscribePlan(subscriptionForm: SubscriptionForm) {
  const response = await axios.post<Response>(
    `${API}/Merchant/BecomeAMerchantChooseSubscriptionPlan`,
    subscriptionForm
  )
  if (response.data.responseResult.result) {
    return {
      status: true,
      message: 'Success',
    }
  } else {
    return {
      status: false,
      message: response.data.responseResult.exceptionDetail,
    }
  }
}
